// extracted by mini-css-extract-plugin
export var aboveInput = "_gm-0";
export var actionButton = "_gm-5";
export var actionButtonContainer = "_gm-1";
export var actionIcon = "_gm-6";
export var aiInfoContainer = "_gm-2";
export var attachmentWrapper = "_gm-7";
export var bold = "_gm-3";
export var checkIcon = "_gm-8";
export var clickingRecipientBar = "_gm-11";
export var commentThreadSwitch = "_gm-a";
export var draftImage = "_gm-b";
export var draftImageContainer = "_gm-c";
export var draftImages = "_gm-e";
export var editButton = "_gm-g";
export var editor = "_gm-f";
export var editorContainer = "_gm-y";
export var editorErrorTooltipWrapper = "_gm-9";
export var headerDivider = "_gm-h";
export var icon = "_gm-i";
export var info = "_gm-j";
export var internal = "_gm-n";
export var internalDivider = "_gm-k";
export var internalMessage = "_gm-l";
export var messageInputCard = "_gm-m";
export var messageInputForm = "_gm-o";
export var messageInputFormInternal = "_gm-p";
export var options = "_gm-q";
export var publicMessageCustomer = "_gm-s";
export var publicMessageMerchant = "_gm-r";
export var removeImageButton = "_gm-d";
export var replyButtons = "_gm-t";
export var showSignatureButton = "_gm-u";
export var spinner = "_gm-v";
export var verticalButtonDivider = "_gm-4";
export var visibilitySelector = "_gm-w";
export var warning = "_gm-x";
export var wrappingText = "_gm-z";
export var writingInternalNoteTopBorder = "_gm-10";